import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Popover } from 'react-bootstrap';

class RejectPopover extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        let positionLeft = this.props.positionLeft;
        let placement = this.props.placement;

        if (this.props.smartPopoverPlacement && window.innerWidth > 640) {
            if (positionLeft + 400 > window.innerWidth) {
                placement = "left";
                positionLeft -=  ReactDOM.findDOMNode(this.props.parent).offsetWidth;
            }
        }

        this.state = {
            positionLeft: positionLeft,
            positionTop: (this.props.positionTop < 0) ? 0 : this.props.positionTop,
            placement: placement,
            parent: this.props.parent,
            smartPopoverPlacement: this.props.smartPopoverPlacement
        };
    }
    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        let positionLeft = nextProps.positionLeft;
        let placement = this.props.placement;

        if (nextProps.smartPopoverPlacement && window.innerWidth > 640) {
            if (positionLeft + 400 > window.innerWidth) {
                placement = "left";
                positionLeft -= ReactDOM.findDOMNode(this).offsetWidth + ReactDOM.findDOMNode(nextProps.parent).offsetWidth - 200;
            }
        }

        this.setState({
            positionLeft: positionLeft,
            positionTop: (nextProps.positionTop < 0) ? 0 : nextProps.positionTop,
            placement: placement,
            parent: nextProps.parent,
        });
    }

    // RENDER METHOD

    render = () => {
        return (
             <Popover placement={this.state.placement} positionLeft={this.state.positionLeft} positionTop={this.state.positionTop}>
                <div className="text-center" >
                    {this.props.message}
                </div>
             </Popover>
        );
    }
}

RejectPopover.propTypes = {
    message: PropTypes.string,
    parent: PropTypes.object,
    placement: PropTypes.string,
    positionLeft: PropTypes.string,
    positionTop: PropTypes.string,
    smartPopoverPlacement: PropTypes.bool
};

export default connect()(RejectPopover);



/** WEBPACK FOOTER **
 ** ./src/app/components/RejectPopover.js
 **/